import { h, Component } from 'preact';
import { FinanceSpinner } from '../glyphs';
import { getIncomeStatement } from '@os/cloudquote';
import AnnualQuarterlySelector from '../annual-quarterly-selector';
import { getDaysInMonth } from '../../lib/util';
import { Header } from '@cube/blocks';
import cx from 'classnames';
import style from './style.less';
import { Text } from 'preact-i18n';
import StockDataTable from '../stock-data-table';

const INTL_NS = 'stock-data-table';
const INTL_NS_IS = 'incomeStatement';

export default class Earnings extends Component {

	handleChangeTimeRange = ({ value: timespan = '' }) => {
		this.setState({ timespan: timespan.toLowerCase() });
	};
	
	setDefaultColumnHeadings = () => {
		// If the earnings data is missing/unavailable, display the default column headings as follows:
		// For 2017 quarterly column headings: Q1'17, Q2'17, Q3'17, Q4'17.
		// For 2017 annual column headings: 12/31/2017, 12/31/2016, 12/31/2016.
		// Fill the data.rows array with standard dates; i.e.,
		// data.rows[0]: ["Q1", "Q1", "2017-03-31", "2017-03-31", 2017]
		// ...
		// data.rows[11]: ["Q4", "Q4", "2015-12-31", "2015-12-31", 2015]
		let data = {};
		data.columns = [ 'Fiscal Quarter', 'Calendar Quarter', 'Reported Date', 'Filing Date', 'Fiscal Year'];
		data.rows = [];

		let currYear = (new Date()).getFullYear();
		let numYear, numQtr, currMonth, qtrDate, i=0;
		let dashStr = '-';
		let q3EndMonth = 9;

		for (numYear=0; numYear<3; numYear++) {
			for (numQtr=1; numQtr<=4; numQtr++) {
				currMonth = numQtr * 3;
				qtrDate = currYear + dashStr + (currMonth <= q3EndMonth ? '0' : '') + currMonth +  dashStr + getDaysInMonth(currMonth,currYear);
				data.rows[i++] = ['Q'+numQtr, 'Q'+numQtr, qtrDate, qtrDate, currYear];
			}
			currYear--;
		}
		return data;
	};

	componentWillMount() {
		getIncomeStatement(this.props.symbol).then(
			(data) => {
				if (!data.columns || data.columns.length===0 || !data.rows || data.rows.length===0) {
					data = this.setDefaultColumnHeadings();
				}
				this.setState({ data });
			}
		);
	}

	render(props, { data, timespan='quarterly' }) {
		let rows = data && data.rows;

		if (!rows || !rows.length) {
			return (
				<FinanceSpinner />
			);
		}

		return (
			<div>
				<Header class={cx(style.statisticsHeader, props.class)} title={<Text id={`${INTL_NS}.${INTL_NS_IS}.netIncContOp`} />}>
					<AnnualQuarterlySelector value={timespan} onChange={this.handleChangeTimeRange} anchor="right" />
				</Header>
				<StockDataTable
					data={data}
					compact
					showDates
					cols={[
						{
							name: 'Revenue',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_IS}.revenue`} />
						},
						{
							name: 'Net Income From Continuing Operations',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_IS}.netIncContOpLong`} />
						}
					]}
					timespan={timespan}
				/>
			</div>
		);
	}
}
